import React, { PropsWithChildren } from "react";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const CopyTextField: React.FC<PropsWithChildren> = (props) => {
  return (
    <Grid container item direction="column" className={cssExports.copyTextField}>
      <Grid item className={cssExports.copyTextFieldContent}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default CopyTextField;
